import localSave from '@utils/local-save'

const STORAGE_KEY = 'recentSearches'
const LEGACY_STORAGE_KEY = 'recentSearch' // pre-refactor key, shape: { array, latest }
const MAX_ITEMS = 5

function read() {
    const stored = localSave.get(STORAGE_KEY)
    if (Array.isArray(stored)) return stored
    // Migrate items persisted by the shipped app under the old key/shape.
    const legacy = localSave.get(LEGACY_STORAGE_KEY)
    return Array.isArray(legacy && legacy.array) ? legacy.array : []
}

function write(items) {
    localSave.save(STORAGE_KEY, items)
}

export default {
    getRecent() {
        return read()
    },

    addToRecent(item) {
        let items = read().filter(el => el.id !== item.id)
        if (items.length >= MAX_ITEMS) {
            items = items.slice(items.length - (MAX_ITEMS - 1))
        }
        items.push(item)
        write(items)
        return items
    },

    clearRecent() {
        write([])
    },
}
